import React from "react";
import moment from "moment";
import styles from "./styles.m.css";
import { Link } from "@quintype/components";

const SpecificYearPage = data => {
  let currentYear = new Date().getFullYear();
  const year = Number(data.data.year);
  let currentMonth = new Date().getMonth();
  let months = moment.months();
  return (
    <div className="container">
      <div className={styles["sitemap-wrapper"]}>
        <h1 className={styles["header"]}>
          <Link href={`/site-map`}>Site Map</Link>
        </h1>
        <h3 className={styles["breadcrumb"]}>{data.data.year}</h3>
        <ol className={styles["o-list-year"]}>
          {months.map((month, index) => {
            if ((year === currentYear && index <= currentMonth) || year < currentYear) {
              return (
                <li className={styles["list"]}>
                  <Link href={`/site-map/${year}/${index + 1}`}>{month}</Link>
                </li>
              );
            }
          })}
        </ol>
      </div>
    </div>
  );
};

export { SpecificYearPage };
